import classNames from "classnames";
import { KeyboardEvent } from "react";
import { KEY_CODES, KEYS } from "rivals/shared/constants";
import { setData } from "rivals/shared/utils/qa";
import styles from "./PageToggle.module.scss";
import type { Props } from "./types";

const PageToggle = ({
  activeTabClassName = "",
  className = "",
  disabled = false,
  items,
  onToggle,
  philter = "",
  selected,
  variant
}: Props): JSX.Element => {
  const handleKeyPress = (event: KeyboardEvent<HTMLDivElement>): void => {
    const rightKeyDown =
      event?.key === KEYS.ARROW_RIGHT ||
      event?.keyCode === KEY_CODES.ARROW_RIGHT;
    const leftKeyDown =
      event?.key === KEYS.ARROW_LEFT || event?.keyCode === KEY_CODES.ARROW_LEFT;

    if (rightKeyDown || leftKeyDown) {
      onToggle();
    }
  };

  return (
    <div
      aria-checked="true"
      aria-readonly={disabled}
      className={classNames(styles.wrapper, className, {
        [styles[`${variant}Variant`]]: variant,
        [styles.disabled]: disabled
      })}
      onClick={onToggle}
      onKeyUp={handleKeyPress}
      role="switch"
      tabIndex={0}
      {...setData(philter)}
    >
      {items.map(({ key, title }) => (
        <div
          className={classNames(styles.tab, {
            [activeTabClassName || styles.selectedTab]: selected === key
          })}
          key={key}
        >
          {title}
        </div>
      ))}
    </div>
  );
};

export default PageToggle;
